import { render, staticRenderFns } from "./TaskDialog.vue?vue&type=template&id=67ee3f3f"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskDialog.vue?vue&type=style&index=0&id=67ee3f3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports